/**
 * @module profile/container/portfolio/entry_details
 */
import { connect } from 'react-redux';
import EntryDetails from 'profile/components/portfolio/entry_details';
import { resetZoom, getEntryModalState, zoomInEntry, zoomOutEntry,
  setEntryDetailsPage } from 'profile/ducks/portfolio_entry';
import { getPortfolio, fetchPortfolioEntry } from 'profile/ducks/portfolio';

function mapStateToProps(state) {
  const portfolioState = getPortfolio(state);
  const singleEntryState = getEntryModalState(state);

  return {
    entryDetailsState: { ...singleEntryState },
    pageState: { ...portfolioState },
    user: state.user,
    itemsCount: portfolioState.itemsCount,
    currentPage: singleEntryState.currentPage,
  };
}

export default connect(mapStateToProps, {
  zoomInEntry,
  zoomOutEntry,
  resetZoom,
  setEntryDetailsPage,
  fetchEntry: fetchPortfolioEntry,
})(EntryDetails);



// WEBPACK FOOTER //
// ./profile/containers/portfolio/entry_details.jsx